import { createAsyncThunk } from '@reduxjs/toolkit';
import { getThreadVideoSessions } from 'store/chat/services/getThreadVideoSessions.service';

export const getThreadVideoSessionsThunk = createAsyncThunk(
  'chat/getThreadVideoSessions',
  async (_, { getState }) => {
    const { thread } = getState().chatSlice;
    const sessions = await getThreadVideoSessions(thread);
    return sessions;
  }
);
